export default {
    strategyOptions: (state) =>
      state.tradeList.map(trade => ({
        tradeId: trade.tradeId,
        strategyName: trade.strategyName
      }))
  };